import { useState } from "react"
import { Archive } from "lucide-react"
import { PostfachMailModal } from "./PostfachMailModal"

/**
 * Hinweis für Mails, deren Inhalt der Datenschutz-Löschjob nach 90 Tagen
 * geleert hat (DSGVO, 02.10.2026). Das Original liegt weiter im Postfach des
 * Kunden — „Im Postfach öffnen“ lädt es live und nur lesend
 * (GET /api/v1/emails/postfach-mail mit message_id + Ordner).
 *
 * Ohne IMAP-Zugang des Mandanten (`postfachVerfuegbar` false) oder ohne
 * Message-ID bleibt es beim Hinweis — ein Knopf, der nur „nicht gefunden“
 * liefern kann, hilft niemandem.
 *
 * `kompakt`: nur der Knopf (für Listenzeilen, deren Titel den Hinweis schon
 * trägt).
 */
export function InhaltEntferntHinweis({
  tenant, messageId, folder, postfach, postfachVerfuegbar, kompakt = false,
}: {
  tenant: string
  messageId?: string | null
  folder?: string | null
  postfach?: string | null
  postfachVerfuegbar?: boolean | null
  kompakt?: boolean
}) {
  const [offen, setOffen] = useState(false)
  const knopf = !!(postfachVerfuegbar && messageId && tenant)

  if (kompakt && !knopf) return null
  return (
    <>
      <span
        data-testid="inhalt-entfernt"
        style={{
          display: "inline-flex", alignItems: "center", gap: 8, flexWrap: "wrap",
          fontSize: 12.5, color: "#64748b",
        }}
      >
        {!kompakt && <span style={{ fontStyle: "italic" }}>Inhalt nach 90 Tagen entfernt</span>}
        {knopf && (
          <button
            type="button"
            data-testid="im-postfach-oeffnen"
            onClick={(ev) => {
              // In Listenzeilen öffnet ein Klick sonst zusätzlich die Zeile.
              ev.stopPropagation()
              setOffen(true)
            }}
            style={{
              display: "inline-flex", alignItems: "center", gap: 5,
              fontSize: 12, fontWeight: 600, color: "#0f172a", background: "#f1f5f9",
              border: "1px solid #e2e8f0", borderRadius: 6, padding: "2px 9px",
              cursor: "pointer",
            }}
          >
            <Archive style={{ width: 12, height: 12 }} />
            Im Postfach öffnen
          </button>
        )}
      </span>
      {/* React reicht Klicks auch aus einem Portal an die Vorfahren weiter —
          ohne den Riegel öffnete ein Klick im Fenster die Listenzeile. */}
      <span onClick={(ev) => ev.stopPropagation()}>
        {offen && (
          <PostfachMailModal
            tenant={tenant}
            postfach={postfach}
            folder={folder || ""}
            messageId={messageId || undefined}
            onClose={() => setOffen(false)}
          />
        )}
      </span>
    </>
  )
}
